// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"952":"f638167d","2207":"93c39598","3562":"68af68ab","4231":"bbe38345","4397":"9ee60538","4677":"620cb311","4858":"af3b9f08","5577":"147ea34a","5682":"7b0d521a","5811":"7b0d521a","9982":"93c39598"}[chunkId] + ".chunk.css";
};